import { queryOptions, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

import type { PushScenarioToggle } from '../model/types';

export const getPushScenariosAPI = async () => {
  const response = await baseAPI.get<{ scenarios: Array<PushScenarioToggle> }>(
    'mobile-inventor-push/scenarios',
  );
  return response.data;
};

export const getPushScenariosOptions = () =>
  queryOptions({
    queryKey: QUERY_KEYS.MOBILE_INVENTOR_PUSH_SCENARIOS(),
    queryFn: getPushScenariosAPI,
  });

export const useGetPushScenarios = () => useQuery(getPushScenariosOptions());
